import React from 'react';
import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Edit from './Edit'; // your existing Edit form

export default function EditDrawer({ open, onClose, product, setproduct }) {
  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: 400, padding: 2, position: 'relative' }}>
        
        {/* ❌ Close Button */}
        <IconButton
          onClick={onClose}
          sx={{ position: 'absolute', top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>

        {/* ✏️ Edit Form */}
        <Edit
          product={product}
          setproduct={setproduct}
          setShowproduct={onClose}
        />
      </Box>
    </Drawer>
  );
}


